import { render, staticRenderFns } from "./Fuse.vue?vue&type=template&id=633d838f&scoped=true&"
import script from "./Fuse.vue?vue&type=script&lang=js&"
export * from "./Fuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d838f",
  null
  
)

export default component.exports